var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col relative h-full overflow-y-hidden"},[_c('embedded-chat-body',{staticClass:"flex-1 overflow-y-auto"}),_c('embedded-chat-bottom',{staticClass:"flex-shrink-0 mt-auto"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }